import { ArrowLink } from "./ArrowLink";
import React from "react";

interface NavColumnGroupProps {
  heading?: string;
  children: React.ReactNode;
  cta?: {
    text: string;
    href: string;
  };
}

export const NavColumnGroup = ({
  heading,
  children,
  cta,
}: NavColumnGroupProps) => (
  <div className="flex flex-col">
    {heading && (
      <h2 className="text-xl-semibold text-brand-primary m-0 px-xl py-md">
        {heading}
      </h2>
    )}
    <div className="flex gap-xl pt-4xl flex-1">{children}</div>
    {cta && (
      <div className="px-xl py-md">
        <ArrowLink href={cta.href}>{cta.text}</ArrowLink>
      </div>
    )}
  </div>
);
